import React, { Component } from 'react';
import './index.scss';

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="footer" >
                <div className='footerLeft' >
                    <div className='logoFooter'>
                        <img src="assets/footer_content_left.png" height="70" alt=""/>
                    </div>
                    {/*<div className='textFooter'>*/}
                        {/*<span className='text1'>ความไว้วางใจจากลูกค้า</span>*/}
                        {/*<br/>*/}
                        {/*<span className='text2'>คือความภูมิใจของเรา</span>*/}
                    {/*</div>*/}
                </div>
                <div className='footerRight'>
                    <img onClick={()=>{ window.open("tel:1775")}} src="assets/footer_content_right.png" height="70" alt=""/>
                </div>
            </div>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/index.js